import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'


// lazy load
const HomeSearchView = () => import('../views/Home/Main/HomeSearch.vue')
const GenomeView = () => import('../views/Genome/GenomeView.vue')
const GeneDetailsView = () => import('../views/Genome/Details/GeneDetails.vue') 
const BlastView = () => import('../views/Tools/Blast/GeneBlast.vue')
const UploadBlastView = () => import('../views/Upload/Blast/GeneBlast.vue')
const UploadEnrichView = () => import('../views/Upload/Enrichment/GoEnrich.vue')
const UploadKeggView = () => import('../views/Upload/Kegg/Kegg.vue')
const BrowserView = () => import('../views/Tools/Browser/BrowserView.vue')
const GoEnrichView = () => import('../views/Tools/Enrichment/GoEnrich.vue')
const IDConversionView = () => import('../views/Tools/Conversion/IDConversion.vue')
const SyntenyView = () => import('../views/Tools/Synteny/SyntenyView.vue')
const PrimerView = () => import('../views/Tools/Primer/PrimerView.vue')
const DownloadView = () => import('../views/Download/DownloadView.vue')
const HelpView = () => import('../views/Help/HelpView.vue')
const NotFound = () => import('../components/error/NotFound.vue')
const SubmitView = () => import('../views/Tools/Submit/SubmitView.vue')
const FetchSeqView = () => import('../views/Tools/FetchSeq/FetchSeqView.vue')
const MsaView = () => import('../views/Tools/MSA/MsaView.vue')
const ideogramView = () => import('../views/Tools/Ideogram/Ideogram.vue')
const idteloView = () => import('../views/Tools/Idtelo/Idtelo.vue')
const liftoffView = () => import('../views/Tools/Liftoff/Liftoff.vue')
const idcentroView = () => import('../views/Tools/Idcentro/Idcentro.vue')
const keggView = () => import('../views/Tools/Kegg/Kegg.vue')
const fimoView = () => import('../views/Tools/Fimo/Fimo.vue')
const UploadView = () => import('../views/Upload/SubmitView.vue')
const UploadGenomeView = () => import('../views/Upload/Genome/UlGenomeView.vue')
const UploadGeneDetailsView = () => import('../views/Upload/Genome/Details/UlGeneDetails.vue')
const TaskstatusView = () => import('../views/Upload/SpeciesStatus.vue')


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'Home page of T2T-Hub',
      keepAlive : true 
    },
    component: HomeView
  },
  {
    path: '/home/search',
    name: 'search',
    component: HomeSearchView
  },
  {
    path: '/genome/:species',
    name: 'genome',
    meta: {
      keepAlive : true 
    },
    component: GenomeView,
  },
  {
    path: '/genome/:species/details',
    name: 'gdetails',
    component: GeneDetailsView
  },
  // Tools
  {
    path: '/tools/blast',
    name: 'blast',
    // meta: {
    //   keepAlive : true 
    // },
    component: BlastView
  },
  {
    path: '/tools/browser',
    name: 'browser',
    meta: {
      keepAlive : true 
    },
    component: BrowserView
  },
  {
    path: '/tools/enrichment',
    name: 'enrichment',
    meta: {
      keepAlive : true 
    },
    component: GoEnrichView
  },
  {
    path: '/tools/idconv',
    name: 'idconv',
    meta: {
      keepAlive : true 
    },
    component: IDConversionView
  },
  {
    path: '/tools/synteny',
    name: 'synteny',
    meta: {
      keepAlive : true 
    },
    component: SyntenyView
  },
  {
    path: '/tools/primer',
    name: 'primer',
    meta: {
      keepAlive : true 
    },
    component: PrimerView
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      keepAlive : true 
    },
    component: DownloadView
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      keepAlive : true 
    },
    component: HelpView
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/tools/submit',
    name: 'submit',
    component: SubmitView
  },
  {
    path: '/upload',
    name: 'upload',
    component: UploadView
  },
  {
    path: '/upload/:id',
    name: 'ulgenome',
    meta: {
      keepAlive : true 
    },
    component: UploadGenomeView,
  },
  {
    path: '/upload/:id/details',
    name: 'ulgdetails',
    component: UploadGeneDetailsView
  },
  {
    path: '/ultool/blast',
    name: 'uploadblast',
    props: route => ({ id: route.query.id}),
    component: UploadBlastView
  },
  {
    path: '/ultool/enrichment',
    name: 'uploadenrichment',
    props: route => ({ id: route.query.id}),
    component: UploadEnrichView
  },
  {
    path: '/ultool/kegg',
    name: 'uploadkegg',
    props: route => ({ id: route.query.id}),
    component: UploadKeggView
  },
  {
    path: '/taskstatus/:taskid',
    name: 'taskstatus',
    component: TaskstatusView,
  },
  {
    path: '/tools/fetchseq',
    name: 'fetchseq',
    component: FetchSeqView
  },
  {
    path: '/tools/msa',
    name: 'msa',
    component: MsaView
  },
  {
    path: '/tools/ideogram',
    name: 'ideogram',
    component: ideogramView
  },
  {
    path: '/tools/idtelo',
    name: 'idtelo',
    component: idteloView
  },
  {
    path: '/tools/liftoff',
    name: 'liftoff',
    component: liftoffView
  },
  {
    path: '/tools/idcentro',
    name: 'idcentro',
    component: idcentroView
  },
  {
    path: '/tools/kegg',
    name: 'kegg',
    component: keggView
  },
  {
    path: '/tools/fimo',
    name: 'fimo',
    component: fimoView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes,
})

export default router
